import React from 'react';
import './CSS/Quote.css';

function Quote() {
  return (
    <div className="quote">
      <p>Mathematics is the most beautiful and most powerful creation of the human spirit.</p>
      <p className="name">Stefan Banach</p>
    </div>
  );
}

export default Quote;
